import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import swDev from './swDev';
import { TimeSheetProvider } from './Config/TimeSheetContext';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <TimeSheetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </TimeSheetProvider>
);
swDev();
